SP.CategoryNavigation = Garnish.Base.extend({
    $el: null,

    init(el) {
        this.$el = el
        let triggerLink = this.$el.find('.hasSubcategory > a')

        this.addListener(triggerLink, 'click', this.expand)
    },

    expand(ev) {
        ev.preventDefault()
        let target = $(ev.currentTarget).parent()

        if (target.hasClass('active')) {
            target.removeClass('active')
            target.find('.subcategory').slideUp()
        } else {
            $('.subcategory').slideUp()
            $('.hasSubcategory').removeClass('active')
            target.addClass('active')
            target.find('.subcategory').slideDown()
        }
    },

    collapse() {

    }
})